import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field, Section } from "./Field";
import { STATI_ATTIVITA } from "@/lib/card";

const Full = ({ children }) => <div className="sm:col-span-2">{children}</div>;

export const CameraliTab = ({ card, set }) => (
  <div className="space-y-6">
    <Section title="Identificazione" hint="I dati camerali compaiono nella scheda pubblica solo se compilati.">
      <Full><Field label="Ragione sociale" value={card.company_name} onChange={set("company_name")} testId="input-ragione-sociale" /></Full>
      <Field label="Forma giuridica" value={card.forma_giuridica} onChange={set("forma_giuridica")} testId="input-forma-giuridica" placeholder="Es. Società a responsabilità limitata" />
      <Field label="Partita IVA" value={card.piva} onChange={set("piva")} testId="input-piva" />
      <Field label="Codice fiscale" value={card.cf} onChange={set("cf")} testId="input-cf" />
      <div className="space-y-2">
        <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Stato attività</Label>
        <Select value={card.stato_attivita || "Attiva"} onValueChange={set("stato_attivita")}>
          <SelectTrigger className="bg-white" data-testid="select-stato-attivita"><SelectValue /></SelectTrigger>
          <SelectContent>
            {STATI_ATTIVITA.map((s) => <SelectItem key={s} value={s} data-testid={`stato-option-${s.replace(/\s/g, "-").toLowerCase()}`}>{s}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </Section>
    <Section title="Registro Imprese">
      <Full><Field label="Camera di Commercio" value={card.camera_commercio} onChange={set("camera_commercio")} testId="input-camera-commercio" placeholder="Es. CCIAA Milano Monza Brianza Lodi" /></Full>
      <Field label="Numero REA" value={card.numero_rea} onChange={set("numero_rea")} testId="input-numero-rea" placeholder="Es. MI-1234567" />
      <Field label="Data costituzione" value={card.data_costituzione} onChange={set("data_costituzione")} testId="input-data-costituzione" type="date" />
      <Full><Field label="Capitale sociale" value={card.capitale_sociale} onChange={set("capitale_sociale")} testId="input-capitale-sociale" placeholder="Es. € 10.000,00 i.v." /></Full>
    </Section>
    <Section title="Sede e Attività">
      <Full><Field label="Sede legale" value={card.sede_legale} onChange={set("sede_legale")} testId="input-sede-legale" placeholder="Via, CAP, Città (Prov.)" /></Full>
      <Field label="Codice ATECO" value={card.codice_ateco} onChange={set("codice_ateco")} testId="input-codice-ateco" placeholder="Es. 62.01.00" />
      <Field label="Settore attività" value={card.settore_attivita} onChange={set("settore_attivita")} testId="input-settore-attivita" />
      <Full><Field label="Legale rappresentante" value={card.legale_rappresentante} onChange={set("legale_rappresentante")} testId="input-legale-rappresentante" /></Full>
    </Section>
  </div>
);
